import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import industrialvisitService from "./industrialService";

export const getIndustrialvisit = createAsyncThunk(
  "industrialvisit/get-industrialvisit",
  async (_, thunkAPI) => {
    try {
      return await industrialvisitService.getIndustrialvisit();
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const getIndustrialvisitmenu = createAsyncThunk(
  "industrialvisit/get-industrialvisitmenu",
  async (_, thunkAPI) => {
    try {
      return await industrialvisitService.getIndustrialvisitmenu();
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const resetState = createAction("Reset_all");

const initialState = {
  industrialvisits: [],
  isError: false,
  isLoading: false,
  isSuccess: false,
  message: "",
};

export const industrialvisitSlice = createSlice({
  name: "industrialvisit",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getIndustrialvisit.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getIndustrialvisit.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.industrialvisits = action.payload;
      })
      .addCase(getIndustrialvisit.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message =
          action.error.message || "Failed to fetch industrial visits";
      })
      .addCase(getIndustrialvisitmenu.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getIndustrialvisitmenu.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.industrialvisits = action.payload.data; // Extract the 'data' array
      })
      .addCase(getIndustrialvisitmenu.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message =
          action.error.message || "Failed to fetch industrial visits";
      })
      .addCase(resetState, () => initialState);
  },
});

export default industrialvisitSlice.reducer;
